// extracted by mini-css-extract-plugin
export default {"tapaderaContainer":"App_tapaderaContainer__OSJ1z","tapadera":"App_tapadera__+HDBf"};